import { chatClient, memberClient } from '../config/Apollo';

export const network = {
  state: {
    client: chatClient,
    memberClient: memberClient,
  },
};
